var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Tab as MuiTab } from "@mui/material";
import { useMemo } from "react";
import { COLORS } from "../../../constants";
import LoadingSkeleton from "../LoadingSkeleton";
import CircularProgress from "../Progress/CircularProgress";
import Text from "../Text";
import { tabStylesFn } from "./SecondaryTab.styles";
var SecondaryTab = function (_a) {
    var label = _a.label, loading = _a.loading, disabled = _a.disabled, value = _a.value, activeIcon = _a.activeIcon, icon = _a.icon, sx = _a.sx, _b = _a.iconPosition, iconPosition = _b === void 0 ? "start" : _b, _c = _a.disableRipple, disableRipple = _c === void 0 ? true : _c, _d = _a.size, size = _d === void 0 ? "medium" : _d, rest = __rest(_a, ["label", "loading", "disabled", "value", "activeIcon", "icon", "sx", "iconPosition", "disableRipple", "size"]);
    var styles = useMemo(function () { return tabStylesFn(size); }, [size]);
    var selected = rest.selected;
    // if activeIcon is passed, use when active
    var iconToUse = selected ? activeIcon || icon : icon;
    var sxProps = __assign(__assign({}, styles), sx);
    return (_jsx(MuiTab, __assign({ "data-testid": "button-tab-".concat(value), tabIndex: 0, value: value, icon: iconToUse, iconPosition: iconPosition, disableRipple: disableRipple, sx: sxProps, disabled: disabled, label: !loading ? (_jsx(Text, __assign({ lineHeight: "24px", component: "span", variant: selected ? "subtitle2" : "body2", shade: selected ? "say" : "dark" }, { children: label }))) : (_jsxs(Stack, __assign({ direction: "row", alignItems: "center", gap: 3 }, { children: [_jsx(CircularProgress, { size: 18, sx: { color: COLORS.P_OUTLINE } }), _jsx(LoadingSkeleton, { sx: { width: "80px" } })] }))) }, rest)));
};
export default SecondaryTab;
